export default {"src":"/_next/static/media/chat-text.c75d4a60.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};